import * as React from 'react';
// import 'rc-tooltip/assets/bootstrap.css';
import Slider from 'rc-slider';
import HandleTooltip from './HandleTooltip';


export const handleRender = (node, props) => {
    return (
        <HandleTooltip value={props.value} visible={props.dragging}>
            {node}
        </HandleTooltip>
    );
};

const TooltipSlider = ({tipFormatter, tipProps, ...props}) => {
    const tipHandleRender = (node, handleProps) => {
        return (
            <HandleTooltip onClick={props.handleClick} onTouchStart={props.handleClick}
                value={handleProps.value}
                visible={handleProps.dragging? true: undefined}
                tipFormatter={tipFormatter}
                {...tipProps}
            >
                {node}
            </HandleTooltip>
        );
    };


    // eslint-disable-next-line react/jsx-no-bind
    return <Slider {...props} handleRender={tipHandleRender} />;
};

export default TooltipSlider;
